export default __webpack_public_path__ + "static/media/ico_verify.48d82656.svg";